/** 로그인 */
export default {
  label: {
    code: 'SMS 로그인',
    pswd: '비밀번호 로그인'
  },
  phone: '휴대폰 번호',
  password: '로그인 비밀번호',
  code: '{type} 인증',
  sms: 'SMS',
  img: '이미지',
  getCode: '전송',
  login: '로그인',
  // 가맹점 선택
  choose: '가맹점 선택',
  // 안내사항
  agree: '미등록 휴대폰 번호는 자동으로 등록됩니다. 체크는 동의 및 수락을 의미합니다',
  agreement: '《가맹점 플랫폼 이용약관》',
  second: '초',
  // WeChat 로그인
  wx: 'WeChat 로그인',
  // 이벤트 관리 플랫폼
  activity_platform: {
    title: '이벤트 관리 플랫폼',
    subtitle: '단순에서 복잡까지, 무한한 변화와 설정으로 이벤트 요구사항 충족',
    features: [
      '여러 라운드와 카테고리 그룹으로 대규모 이벤트 개최',
      '인기 순위로 이벤트 노출도 증가',
      '광고 로딩으로 다양한 프로모션 실현',
      '다각적 평가로 최적의 참가자 선정',
      '이미지와 동영상 업로드로 다채로운 현장 표현'
    ]
  },
  // 평가 및 승급
  evaluation: {
    title: '평가 및 승급',
    subtitle: '다각적 평가로 가장 공정하고 공식적인 선발 점수 산정',
    features: [
      '다른 그룹에 다각적 채점 방식을 설정, 복합적 선발',
      '채점, 심사 두 가지 평가 방식 중 선택',
      '여러 심사위원이 동시에 평가 및 채점하여 공정한 권위 확보',
      '참가자 평가 성적에 따른 선별, 승급 및 탈락을 원클릭으로 조작',
      '우수 참가자에게 상장과 순위 부여'
    ]
  },
  // 멋진 순간
  moments: {
    title: '멋진 순간',
    subtitle: '이미지와 동영상으로 이벤트의 멋진 순간 기록',
    features: [
      '이미지나 동영상을 업로드하여 모바일에서 멋진 순간의 추억으로 공개',
      '태그와 카테고리로 이미지와 동영상을 분류하여 효율적으로 관리',
      '이미지와 동영상 다운로드로 사용자가 하이라이트를 영구 보관 가능'
    ]
  },
  // 인기 순위
  popularity: {
    title: '인기 순위',
    subtitle: '순위 목록으로 이벤트의 인기를 완벽하게 표현',
    features: [
      '좋아요 순위, 1인 1표로 이벤트의 높은 인기 표현',
      '선물 순위, 지지하는 인기 참가자에게 기여',
      '여러 단계의 순위로 각 단계의 인기 표시',
      '여러 그룹의 순위로 각 그룹의 인기 참가자 표시'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/langs/ko/login.js